import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import translations
import amTranslation from "./locales/am/translation.json";
import enTranslation from "./locales/en/translation.json";
import omTranslation from "./locales/om/translation.json";
import tiTranslation from "./locales/ti/translation.json";

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    debug: import.meta.env.DEV,
    fallbackLng: "en",
    supportedLngs: ["en", "am", "ti", "om"],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false,
    },
    resources: {
      en: {
        translation: enTranslation,
      },
      am: {
        translation: amTranslation,
      },
      ti: {
        translation: tiTranslation,
      },
      om: {
        translation: omTranslation,
      },
    },
  });

export default i18n;
